import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Media from "./Media";

const LeftBanner = () => {
  const [text] = useTypewriter({
    words: [
      "Backend Engineer.",
      "Platform Engineer.",
      "Cloud & DevOps.",
      "Microservices Architect.",
    ],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });

  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className="text-lg font-normal">WELCOME TO MY WORLD</h4>
        <h1 className="text-6xl font-bold text-white">
          Hi, I'm{" "}
          <span className="text-designColor capitalize">Biprodas Barai</span>
        </h1>
        <h2 className="text-4xl font-bold text-white">
          a <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#ff014f"
          />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">
          Backend & Platform Engineer with 2+ years building
          production-grade cloud systems for a US-based e-commerce company.
          I've architected and shipped more than five production backend systems — covering
          pricing automation, warehouse management, and multi-platform
          marketplace integrations (Amazon, Walmart, TikTok Shop, Etsy). I
          operate across the full backend-to-infrastructure stack: designing REST
          APIs, deploying microservices on Kubernetes, and owning CI/CD pipelines
          end-to-end. I graduated with a BSc in Computer Science and Engineering
          from Chittagong University of Engineering and Technology (CUET).
        </p>
      </div>
      {/* Media */}
      <Media />
    </div>
  );
};

export default LeftBanner;